import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  sideNavButton$: EventEmitter<any>;
  sideNavFocusChange$: EventEmitter<any>;
  tabChange$: EventEmitter<string>;

  constructor() {
    this.sideNavButton$ = new EventEmitter();
    this.sideNavFocusChange$ = new EventEmitter();
    this.tabChange$ = new EventEmitter();
  }

  sideNavButtonEvent(): void {
    this.sideNavButton$.emit();
  }

  sideNavFocusChangeEvent(): void {
    this.sideNavFocusChange$.emit();
  }

  tabChangeEvent(newTab: string): void {
    this.tabChange$.emit(newTab);
  }
}
